import styled, { css, type RuleSet } from 'styled-components';
import { breakpoint } from 'styles/globals';
import type { Theme } from 'styles/theme';

const layoutStyling: {
  [breakpoint: string]: {
    [variant: string]: RuleSet<any>;
  };
} = {
  'education-section-rankings': {
    initial: css`
      grid-template-columns: 1fr;
      gap: 24px;
    `,
    mdMin: css`
      gap: 40px;
    `,
    lgMin: css`
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto auto 1fr;
      gap: 40px 24px;
      & > * {
        grid-column: 2;
      }
      & > *:nth-child(1) {
        grid-column: 1;
        grid-row: 1 / 4;
        grid-auto-rows: min-content;
      }
    `,
  },
  'best-programs-category-page': {
    initial: css<{ theme: Theme }>`
      grid-template-columns: 1fr;
      gap: var(--Grid-Gap);
    `,
    mdMin: css`
      grid-template-columns: repeat(2, 1fr);
    `,
    lgMin: css`
      grid-template-columns: repeat(4, 1fr);
    `,
  },
  'rankings-list-category-page': {
    initial: css<{ theme: Theme }>`
      grid-template-columns: 1fr;
      gap: 40px var(--Grid-Gap);
    `,
    mdMin: css`
      grid-template-columns: repeat(2, 1fr);
    `,
  },
  'more-best-rankings': {
    initial: css<{ theme: Theme }>`
      grid-template-columns: 1fr;
      row-gap: 24px;
    `,
    mdMin: css`
      grid-template-columns: repeat(2, 1fr);
      gap: 24px var(--Grid-Gap);
    `,
    lgMin: css`
      grid-template-columns: repeat(4, 1fr);
    `,
  },
};

export const CardsWrapper = styled.div<{
  $variant:
    | 'education-section-rankings'
    | 'best-programs-category-page'
    | 'rankings-list-category-page'
    | 'more-best-rankings';
}>`
  display: grid;
  
  ${({ $variant }) => layoutStyling[$variant].initial || ''};

  @media (${breakpoint.mdMin}) {
    ${({ $variant }) => layoutStyling[$variant].mdMin || ''};
  }

  @media (${breakpoint.lgMin}) {
    ${({ $variant }) => layoutStyling[$variant].lgMin || ''};
  }

  @media (${breakpoint.xlMin}) {
    ${({ $variant }) => layoutStyling[$variant].xlMin || ''};
  }
`;
